import React, { useEffect, useState } from 'react';

import {
  MARKETPLACE_ENTRY,
  STUDIO_DASHBOARD_COMMUNITY_TEMPLATES,
  STUDIO_DASHBOARD_CUSTOM_TEMPLATES,
  studioCommunityTemplatesPage,
  studioCustomTemplatesPage,
  TEMPLATES_GALLERY_ENTRY,
} from '@utils/constants';
import { marketplacePath, templatesPath } from './useRouter';

export const useTemplateEntry = () => {
  const [entry, setEntry] = useState<string | null>();

  useEffect(() => {
    if (!document || !document.referrer) return;
    const referrer = document.referrer;
    let entryType = null;
    if (referrer.includes(templatesPath)) {
      entryType = TEMPLATES_GALLERY_ENTRY;
    } else if (referrer.includes(studioCommunityTemplatesPage)) {
      entryType = STUDIO_DASHBOARD_COMMUNITY_TEMPLATES;
    } else if (referrer.includes(studioCustomTemplatesPage)) {
      entryType = STUDIO_DASHBOARD_CUSTOM_TEMPLATES;
    } else if (referrer.includes(marketplacePath)) {
      entryType = MARKETPLACE_ENTRY;
    }
    setEntry(entryType);
  }, []);

  return {
    entry,
  };
};
